






























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import CardModalSKDP from "@/components/modal/CardModalSKDP.vue";
@Component({
  components: {
    CardModalSKDP,
  },
})
export default class CardModalKasusSkdp extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() readonly register!: string;
  modalSKDP = false;
  dataSkdp = {};
  statusKronis = "0";
  expandInput = false;

  get show() {
    return this.value;
  }

  set show(value) {
    this.$emit("input", value);
  }

  kronis() {
    this.dataSkdp = {};
    this.show = false;
    this.statusKronis = "1";
    this.modalSKDP = true;
    this.$emit("selected", this.statusKronis);
  }

  nonkronis() {
    this.dataSkdp = {};
    this.show = false;
    this.statusKronis = "0";
    this.modalSKDP = true;
    this.$emit("selected", this.statusKronis);
  }

  passTtd(value) {
    this.$emit("passTtd", value);
  }
}
